const LG_POINT = 1024;

export { LG_POINT };
